<template>
    <div class="content" style="padding-top: 80px">
        profile
    </div>
</template>